import React from 'react'
import { withRouter } from 'react-router-dom'

import 'primeicons/primeicons.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import 'primereact/resources/primereact.css'
import 'primeflex/primeflex.css'
import './DropdownDemo.css'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'

import { AgGridReact } from 'ag-grid-react'
import { Toolbar } from 'primereact/toolbar'
import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { notification } from 'antd'

import { api, request } from '../../util/handlerRequestUtil'
import ConfirmImportModal from '../../components/ModalDataLoad/modalDataLoad'
import { getCurrentReferencePeriodId } from '../../util/getCurrentReferencePeriod'

const MAX_MB = 250
const isXlsxByName = (name = '') => name.toLowerCase().endsWith('.xlsx')

const IMPORT_LABEL = {
  VISITA_GD_EXTERNA_CREATE: 'Criação Visita GD Externa',
  VISITA_GD_EXTERNA_UPDATE: 'Atualização Visita GD Externa'
}

const getLoggedUserId = () => {
  const raw = window.localStorage.getItem('userId')
  const n = Number(raw)
  return Number.isFinite(n) && n > 0 ? n : null
}

const pad2 = (n) => String(n).padStart(2, '0')

const formatDateTimeMinusHours = (input, minusHours = 0) => {
  if (!input) return ''

  let d = null

  if (input instanceof Date) {
    d = new Date(input.getTime())
  } else if (typeof input === 'string') {
    const s = input.trim()

    const br = /^(\d{2})\/(\d{2})\/(\d{4})(?:\s*[- ]\s*|\s+)(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(s)
    if (br) {
      const dd = Number(br[1])
      const MM = Number(br[2])
      const yyyy = Number(br[3])
      const hh = Number(br[4])
      const mm = Number(br[5])
      const ss = Number(br[6] || 0)

      d = new Date(Date.UTC(yyyy, MM - 1, dd, hh, mm, ss, 0))
    } else if (/[zZ]|[+-]\d{2}:\d{2}$/.test(s)) {
      d = new Date(s)
    } else {
      const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d{1,3}))?$/.exec(s)

      if (m) {
        const yyyy = Number(m[1])
        const MM = Number(m[2])
        const dd = Number(m[3])
        const hh = Number(m[4])
        const mm = Number(m[5])
        const ss = Number(m[6] || 0)
        const ms = Number((m[7] || '0').padEnd(3, '0'))

        d = new Date(Date.UTC(yyyy, MM - 1, dd, hh, mm, ss, ms))
      } else {
        d = new Date(s)
      }
    }
  } else {
    return ''
  }

  if (!d || Number.isNaN(d.getTime())) return ''

  d = new Date(d.getTime() - minusHours * 60 * 60 * 1000)

  const day = pad2(d.getUTCDate())
  const month = pad2(d.getUTCMonth() + 1)
  const year = d.getUTCFullYear()
  const hour = pad2(d.getUTCHours())
  const minute = pad2(d.getUTCMinutes())

  return `${day}/${month}/${year} - ${hour}:${minute}`
}

class ListDataLoads extends React.Component {
  constructor(props) {
    super(props)

    this.gridApi = null
    this.gridColumnApi = null
    this.fileInputRef = React.createRef()
    this.pollInterval = null

    const tiposVisitas = [{ code: 'VISITA_GD_EXTERNA', name: 'Visita GD Externa' }]

    const tiposImportacao = [
      { code: 'VISITA_GD_EXTERNA_CREATE', name: 'Criação de Visitas', mode: 'create' },
      { code: 'VISITA_GD_EXTERNA_UPDATE', name: 'Atualização de Visitas', mode: 'update' }
    ]

    this.buildColumnDefs = (isAdmin) => [
      {
        headerName: 'Arquivo',
        field: 'originalName',
        flex: 2,
        minWidth: 260,
        getQuickFilterText: (p) => String(p.value ?? '')
      },
      {
        headerName: 'Tipo de Importação',
        field: 'dataTypeLabel',
        flex: 1,
        minWidth: 180,
        valueGetter: (p) => {
          const raw = p.data?.dataTypeLabel
          return IMPORT_LABEL[raw] || raw || ''
        },
        getQuickFilterText: (p) => IMPORT_LABEL[p.data?.dataTypeLabel] || String(p.value ?? '')
      },
      {
        headerName: 'Data',
        field: 'createdAtLabel',
        flex: 1,
        minWidth: 160,
        valueGetter: (p) => {
          const raw = p.data?.createdAt || p.data?.createdAtRaw || p.data?.createdAtLabel || p.value
          return formatDateTimeMinusHours(raw, 3)
        },
        getQuickFilterText: (p) => String(p.value ?? '')
      },
      {
        headerName: 'Usuário',
        field: 'createdByMemberName',
        colId: 'createdByMemberName',
        flex: 1,
        minWidth: 220,
        hide: !isAdmin,
        valueGetter: (p) => {
          const name = p.data?.createdByMemberName
          if (name) return name
          return p.data?.createdByUserEmail || p.data?.createdByUserId || ''
        },
        getQuickFilterText: (p) => String(p.value ?? '')
      },
      { headerName: 'Download', field: 'id', flex: 1, minWidth: 140, cellRenderer: this.renderDownloadButton },
      {
        headerName: 'Status',
        field: 'statusLabel',
        flex: 1,
        minWidth: 140,
        cellRenderer: this.renderStatusCard,
        getQuickFilterText: (p) => String(p.value ?? '')
      }
    ]

    this.state = {
      tiposVisitas,
      selectedTiposVisitas: null,

      tiposImportacao,
      selectedTipoImportacao: null,

      referencePeriods: [],
      selectedReferencePeriod: null,

      context: { componentParent: this },
      defaultColDef: {
        sortable: true,
        resizable: true,
        minWidth: 1,
        width: 100,
        floatingFilter: false
      },
      rowData: [],
      value3: '',
      showConfirmModal: false,
      pickedFile: null,
      pickedFileName: null,
      isSubmitting: false,
      jobId: null,
      jobStatus: null,
      jobProgress: 0,
      jobError: null,
      success: false,
      dataLoadId: null,
      precheckLoading: false,
      existingImport: null,
      replaceChecked: false,
      resultStats: null,
      isAdmin: false,
      isDownloadingTemplate: false,
      columnDefs: this.buildColumnDefs(false)
    }
  }

  canStartImport = () => {
    return !!(
      this.state.selectedTiposVisitas &&
      this.state.selectedTipoImportacao &&
      this.state.selectedReferencePeriod
    )
  }

  canDownloadTemplate = () => {
    return !!(this.state.selectedTiposVisitas && this.state.selectedTipoImportacao)
  }

  notifyInfo = (message, description) => {
    notification.info({ message, description })
  }

  notifyError = (message, description) => {
    notification.error({ message, description })
  }

  applyQuickFilter = (value) => {
    if (!this.gridApi) return

    if (typeof this.gridApi.setGridOption === 'function') {
      this.gridApi.setGridOption('quickFilterText', value)
      return
    }
    if (typeof this.gridApi.setQuickFilterText === 'function') {
      this.gridApi.setQuickFilterText(value)
      return
    }
    if (typeof this.gridApi.setQuickFilter === 'function') {
      this.gridApi.setQuickFilter(value)
      return
    }

    console.warn('Quick filter API não encontrada nesta versão do AG Grid.')
  }

  extractFilenameFromDisposition = (disposition) => {
    if (!disposition) return null
    const m = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(disposition)
    if (!m?.[1]) return null
    try {
      return decodeURIComponent(m[1])
    } catch {
      return m[1]
    }
  }

  componentDidMount() {
    this.refreshGrid()
    this.loadReferencePeriods()
  }

  componentWillUnmount() {
    this.stopPolling()
  }

  loadReferencePeriods = async () => {
    try {
      const referencePeriods = await request(api.listSafraDropdown({ active: true }))
      const currentReferencePeriod = getCurrentReferencePeriodId(referencePeriods)

      this.setState({
        referencePeriods: Array.isArray(referencePeriods) ? referencePeriods : [],
        selectedReferencePeriod: currentReferencePeriod ?? null
      })
    } catch {
      this.setState({ referencePeriods: [], selectedReferencePeriod: null })
    }
  }

  refreshGrid = async () => {
    const resp = await request(api.getDataLoadActionGD())
    const items = resp?.items || []
    const isAdmin = !!resp?.isAdmin

    this.setState({
      rowData: items,
      isAdmin,
      columnDefs: this.buildColumnDefs(isAdmin)
    })
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    this.gridColumnApi = params.columnApi
    this.gridApi.sizeColumnsToFit()
    this.refreshGrid()
  }

  onTipoVisitaChange = (e) => {
    const selected = e.value
    this.setState({
      selectedTiposVisitas: selected,
      selectedTipoImportacao: null
    })
  }

  onTipoImportacaoChange = (e) => {
    const selected = e.value
    this.setState({ selectedTipoImportacao: selected })
  }

  onReferencePeriodChange = (e) => {
    this.setState({ selectedReferencePeriod: e.value })
  }

  handleDownloadTemplate = async () => {
    const mode = this.state.selectedTipoImportacao?.mode
    const visitTypeCode = this.state.selectedTiposVisitas?.code
    const safraId = this.state.selectedReferencePeriod

    if (!visitTypeCode) {
      this.notifyInfo('Atenção', 'Selecione primeiro o Tipo de visita.')
      return
    }

    if (!mode) {
      this.notifyInfo('Atenção', 'Selecione primeiro o Tipo de importação.')
      return
    }

    this.setState({ isDownloadingTemplate: true })

    try {
      const userId = getLoggedUserId()

      await api.downloadDataLoadTemplateByMode({
        visitTypeCode,
        mode,
        userId: mode === 'update' ? userId : undefined,
        safraId
      })
    } catch {
      this.notifyError('Erro', 'Não foi possível baixar o modelo. Confira se o usuário possui visitas cadastradas.')
    } finally {
      this.setState({ isDownloadingTemplate: false })
    }
  }

  openFilePicker = () => {
    if (!this.canStartImport()) {
      this.notifyInfo('Atenção', 'Selecione: Tipo de visita → Tipo de importação.')
      return
    }
    if (!this.fileInputRef.current) return

    this.fileInputRef.current.value = ''
    this.fileInputRef.current.click()
  }

  validatePickedFile = (file) => {
    if (!file) return 'Selecione um arquivo.'
    if (!isXlsxByName(file.name)) return 'Envie um arquivo .xlsx.'
    const mb = file.size / 1024 / 1024
    if (mb > MAX_MB) return `Arquivo acima do limite (${MAX_MB}MB).`
    return null
  }

  onFilePicked = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return

    if (!this.canStartImport()) {
      this.notifyInfo('Atenção', 'Selecione: Tipo de visita → Tipo de importação.')
      return
    }

    const err = this.validatePickedFile(file)
    if (err) {
      this.notifyError('Arquivo inválido', err)
      return
    }

    const dataTypeId = this.state.selectedTipoImportacao?.code
    if (!dataTypeId) {
      this.notifyInfo('Atenção', 'Selecione o Tipo de importação antes.')
      return
    }

    this.setState({
      showConfirmModal: true,
      pickedFile: file,
      pickedFileName: file.name,
      isSubmitting: false,
      jobId: null,
      jobStatus: null,
      jobProgress: 0,
      jobError: null,
      success: false,
      dataLoadId: null,
      precheckLoading: true,
      existingImport: null,
      replaceChecked: false,
      resultStats: null
    })

    try {
      const found = await api.getLatestDataLoad({ dataTypeId, originalName: file.name })
      this.setState({ existingImport: found || null, precheckLoading: false })
    } catch {
      this.setState({ existingImport: null, precheckLoading: false })
    }
  }

  closeConfirmModal = () => {
    this.stopPolling()
    this.setState({
      showConfirmModal: false,
      pickedFile: null,
      pickedFileName: null,
      isSubmitting: false,
      jobId: null,
      jobStatus: null,
      jobProgress: 0,
      jobError: null,
      success: false,
      dataLoadId: null,
      precheckLoading: false,
      existingImport: null,
      replaceChecked: false,
      resultStats: null
    })
  }

  renderDownloadButton = (params) => {
    const dataLoadId = params?.data?.id
    const rawStatus = String(params?.data?.rawStatus || '').toUpperCase()
    const isFinal = rawStatus === 'FAILED' || rawStatus === 'COMPLETED'
    const disabled = !dataLoadId || !isFinal

    const tooltip = disabled
      ? 'Disponível apenas quando a importação finaliza'
      : rawStatus === 'COMPLETED'
        ? 'Baixar resultado (sucesso)'
        : 'Baixar erros'

    return (
      <Button
        className="p-button-text"
        icon="pi pi-download"
        style={{ paddingTop: 0, paddingBottom: 0, marginTop: -4 }}
        tooltip={tooltip}
        tooltipOptions={{ position: 'top' }}
        disabled={disabled}
        onClick={() => this.handleDownloadResults(dataLoadId)}
      />
    )
  }

  handleDownloadResults = async (dataLoadId) => {
    try {
      const resp = await api.downloadDataLoadErrorsXlsx(dataLoadId)
      const dispo = resp?.headers?.['content-disposition'] || resp?.headers?.['Content-Disposition']
      const filename = this.extractFilenameFromDisposition(dispo) || `data-load-${dataLoadId}__resultado.xlsx`

      const blob =
        resp?.data instanceof Blob
          ? resp.data
          : new Blob([resp?.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (e) {
      const msg =
        e?.response?.status === 404
          ? 'Não existe arquivo de resultado para essa importação.'
          : 'Falha ao baixar o XLSX com resultado.'
      this.notifyError('Erro', msg)
    }
  }

  confirmImport = async () => {
    const pickedFile = this.state.pickedFile
    const tipoImport = this.state.selectedTipoImportacao
    const tipoVisita = this.state.selectedTiposVisitas

    if (!pickedFile || !tipoImport || !tipoVisita) {
      this.notifyInfo('Atenção', 'Faltam campos para confirmar a importação.')
      return
    }

    const dataTypeId = tipoImport.code
    const mode = tipoImport.mode
    const visitTypeCode = tipoVisita.code

    this.setState({ isSubmitting: true, jobError: null, success: false })

    try {
      const pres = await api.createUploadUrl()
      const { fileKey, url } = pres.data || {}
      if (!fileKey || !url) throw new Error('Presigned URL inválida.')

      const putResp = await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': pickedFile.type || 'application/octet-stream' },
        body: pickedFile
      })
      if (!putResp.ok) throw new Error('Falha ao enviar arquivo para o storage.')
      const payload = {
        dataTypeId,
        fileKey,
        originalName: pickedFile.name,
        visitTypeCode,
        mode,
        safraId: this.state.selectedReferencePeriod
      }

      const started = await api.startDataLoad(payload)

      const jobId = started?.data?.jobId || started?.data?.id || started?.data?.job?.id
      const dataLoadId =
        started?.data?.dataLoadId || started?.data?.data?.dataLoadId || started?.data?.job?.data?.dataLoadId

      if (!jobId) throw new Error('Backend não retornou jobId.')
      if (!dataLoadId) throw new Error('Backend não retornou dataLoadId.')

      this.setState({ jobId, dataLoadId, jobStatus: 'PENDING', jobProgress: 0, isSubmitting: false })
      this.startPolling(jobId)
    } catch (err) {
      console.error('[START IMPORT] error:', err)
      this.setState({
        isSubmitting: false,
        jobStatus: 'FAILED',
        jobError: err?.message || 'Erro ao iniciar importação.'
      })
    }
  }

  startPolling = (jobId) => {
    this.stopPolling()

    this.pollInterval = window.setInterval(async () => {
      try {
        const resp = await api.getQueueJob(jobId)
        const job = resp.data || resp

        const status = job?.status
        const progress = Number(job?.data?.progress ?? 0)

        this.setState({
          jobStatus: status || this.state.jobStatus,
          jobProgress: Math.max(0, Math.min(100, Math.round(progress)))
        })

        if (status === 'FAILED') {
          this.stopPolling()
          this.setState({ success: false, jobError: job?.data?.error || 'Falha no processamento.' })
          return
        }

        if (status === 'COMPLETED') {
          this.stopPolling()

          const { dataLoadId } = this.state
          if (!dataLoadId) {
            this.setState({
              success: false,
              jobError: 'A importação foi concluída, mas não foi possível identificar o resultado.'
            })
            this.refreshGrid()
            return
          }

          try {
            const fresh = await api.getDataLoadActionsId(dataLoadId)

            const totalRows = Number(fresh?.totalRows ?? 0)
            const successRows = Number(fresh?.successRows ?? 0)
            const errorRows = Number(fresh?.errorRows ?? 0)
            const ignoredRows = Math.max(0, totalRows - successRows - errorRows)

            const hasErrors = String(fresh?.status || '').toUpperCase() === 'FAILED' || errorRows > 0

            const errorMessage = hasErrors
              ? `Falhou com ${errorRows} ${errorRows === 1 ? 'rejeição' : 'rejeições'}. Corrija os erros e faça uma nova inserção!`
              : null

            this.setState({
              success: !hasErrors,
              jobError: hasErrors ? errorMessage : null,
              resultStats: {
                created: successRows,
                ignored: ignoredRows,
                rejected: errorRows
              }
            })
          } catch {
            this.setState({
              success: false,
              jobError: 'A importação foi concluída, mas não foi possível obter o status.'
            })
          }

          this.refreshGrid()
        }
      } catch {
        this.stopPolling()
        this.setState({ jobError: 'Erro ao consultar status do job.' })
      }
    }, 2000)
  }

  stopPolling = () => {
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
      this.pollInterval = null
    }
  }

  renderStatusCard = (params) => {
    const value = params.value
    let background = '#d6dae0'
    let color = '#a0aab6'
    let label = value

    if (value === 'Erro') {
      background = '#f7bcc8'
      color = '#ec6681'
    }
    if (value === 'Processando') {
      background = '#d6dae0'
      color = '#a0aab6'
    }
    if (value === 'Finalizado') {
      background = '#cbf4e5'
      color = '#65daac'
    }

    return (
      <div
        style={{
          background,
          color,
          padding: '2px 5px',
          borderRadius: 4,
          fontWeight: 600,
          fontSize: 13,
          textAlign: 'center',
          display: 'inline-block',
          minWidth: 100,
          lineHeight: '25px'
        }}
      >
        {label}
      </div>
    )
  }

  renderConfirmModal() {
    const {
      showConfirmModal,
      isSubmitting,
      jobStatus,
      jobError,
      success,
      precheckLoading,
      existingImport,
      dataLoadId,
      isDownloadingTemplate
    } = this.state

    const tipoLabel = this.state.selectedTipoImportacao?.name || 'Importação'
    const mode = this.state.selectedTipoImportacao?.mode

    return (
      <ConfirmImportModal
        visible={showConfirmModal}
        onCancel={this.closeConfirmModal}
        onConfirm={this.confirmImport}
        onDownloadTemplate={this.handleDownloadTemplate}
        templateMode={mode}
        dataLoadId={dataLoadId}
        isDownloadingTemplate={isDownloadingTemplate}
        onDownloadErrors={async () => {
          if (!dataLoadId) return
          await this.handleDownloadResults(dataLoadId)
        }}
        tipoLabel={tipoLabel}
        precheckLoading={precheckLoading}
        existingImport={existingImport}
        isSubmitting={isSubmitting || jobStatus === 'PENDING' || jobStatus === 'PROCESSING'}
        jobError={jobError}
        success={success}
        resultStats={this.state.resultStats}
      />
    )
  }

  renderHeader() {
    const tipoImportacaoDisabled = !this.state.selectedTiposVisitas
    const downloadTemplateDisabled = !this.canDownloadTemplate() || this.state.isDownloadingTemplate

    return (
      <Toolbar
        className="data-load-toolbar"
        start={
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <h2 style={{ margin: 0 }}>
              <b>Últimas Importações</b>
            </h2>

            <div
              style={{
                marginTop: 10,
                width: '100%',
                display: 'flex',
                alignItems: 'flex-end',
                gap: 12,
                flexWrap: 'wrap',
                justifyContent: 'flex-start'
              }}
            >
              <input
                ref={this.fileInputRef}
                type="file"
                accept=".xlsx"
                style={{ display: 'none' }}
                onChange={this.onFilePicked}
              />

              {(() => {
                const labelStyle = {
                  fontWeight: 400,
                  fontSize: 14,
                  lineHeight: '16px',
                  marginBottom: 6,
                  height: 16,
                  display: 'flex',
                  alignItems: 'center'
                }

                const fieldStyle = {
                  display: 'flex',
                  flexDirection: 'column',
                  flex: '0 1 240px',
                  minWidth: 180
                }

                const searchFieldStyle = {
                  display: 'flex',
                  flexDirection: 'column',
                  flex: '1 1 260px',
                  minWidth: 220
                }

                const selectStyle = { width: '100%', height: 45 }

                return (
                  <>
                    <div style={searchFieldStyle}>
                      <span style={labelStyle}>Pesquisar</span>
                      <IconField iconPosition="left">
                        <InputIcon className="pi pi-search" />
                        <InputText
                          style={{ width: '100%', height: 45 }}
                          value={this.state.value3}
                          onChange={(e) => {
                            const v = e.target.value
                            this.setState({ value3: v })
                            this.applyQuickFilter(v)
                          }}
                          placeholder="Pesquisar"
                        />
                      </IconField>
                    </div>

                    <div style={fieldStyle}>
                      <span style={labelStyle}>Tipo de visita</span>
                      <Dropdown
                        value={this.state.selectedTiposVisitas}
                        options={this.state.tiposVisitas}
                        onChange={this.onTipoVisitaChange}
                        optionLabel="name"
                        placeholder="Selecione"
                        style={selectStyle}
                      />
                    </div>

                    <div style={fieldStyle}>
                      <span style={labelStyle}>Tipo de importação</span>

                      <div
                        onMouseDown={() => {
                          if (tipoImportacaoDisabled) this.notifyInfo('Atenção', 'Selecione primeiro o Tipo de visita.')
                        }}
                        style={{ display: 'inline-block' }}
                      >
                        <Dropdown
                          value={this.state.selectedTipoImportacao}
                          options={this.state.tiposImportacao}
                          onChange={this.onTipoImportacaoChange}
                          optionLabel="name"
                          placeholder="Selecione"
                          style={selectStyle}
                          disabled={tipoImportacaoDisabled}
                        />
                      </div>
                    </div>

                    <div style={fieldStyle}>
                      <span style={labelStyle}>Safra</span>
                      <Dropdown
                        inputId="dd-safra"
                        value={this.state.selectedReferencePeriod}
                        onChange={this.onReferencePeriodChange}
                        options={this.state.referencePeriods}
                        optionLabel="description"
                        placeholder="Selecione"
                        style={selectStyle}
                      />
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flex: '0 0 auto',
                        gap: 8,
                        alignItems: 'flex-end',
                        marginLeft: 'auto'
                      }}
                    >
                      <Button
                        type="button"
                        className="p-button-outlined"
                        icon={this.state.isDownloadingTemplate ? 'pi pi-spin pi-spinner' : 'pi pi-download'}
                        label="Baixar modelo de preenchimento"
                        disabled={downloadTemplateDisabled}
                        onClick={this.handleDownloadTemplate}
                        style={{ height: 45, whiteSpace: 'nowrap' }}
                      />

                      <Button
                        className="btnNewImport"
                        icon="pi pi-file-import"
                        label="Nova Importação"
                        disabled={!this.canStartImport()}
                        onClick={this.openFilePicker}
                        style={{ height: 45, whiteSpace: 'nowrap' }}
                      />
                    </div>

                    {this.renderConfirmModal()}
                  </>
                )
              })()}
            </div>
          </div>
        }
      />
    )
  }

  render() {
    return (
      <>
        {this.renderHeader()}

        <div style={{ width: '100%', height: '70vh' }}>
          <div style={{ height: '100%', width: '100%' }} className="ag-theme-alpine">
            <AgGridReact
              columnDefs={this.state.columnDefs}
              defaultColDef={this.state.defaultColDef}
              onGridReady={this.onGridReady}
              rowData={this.state.rowData}
              context={this.state.context}
              rowSelection="single"
            />
          </div>
        </div>
      </>
    )
  }
}

export default withRouter(ListDataLoads)
